import { IOverrides } from 'api/overrides.types'
import { getOverrides } from 'api/security'
import axios from 'axios'
import { AppState } from 'store'
import {
  createAsyncReducer,
  createAsyncSelectors,
  getRockefellerApiOptions
} from 'store/shared'
import { call, cancelled, put, takeLatest } from 'typed-redux-saga'
import { createAsyncAction } from 'typesafe-actions'

export const OverridesFetchActions = createAsyncAction(
  '@modules/@security/@overrides/REQUEST',
  '@modules/@security/@overrides/SUCCESS',
  '@modules/@security/@overrides/FAILURE'
)<string | undefined, IOverrides[], Error>()

export const overridesFetchReducer = createAsyncReducer(OverridesFetchActions)

const rootSelector = (state: AppState) => state.modules.overrides.overridesFetch

export const {
  getError: getOverridesFetchError,
  getIsLoading: getOverridesFetchLoading,
  getResult: getOverridesFetchResult
} = createAsyncSelectors(rootSelector)

const onRequest = function* (
  action: ReturnType<typeof OverridesFetchActions.request>
) {
  // eslint-disable-next-line import/no-named-as-default-member
  const source = axios.CancelToken.source()
  const apiOptions = yield* call(getRockefellerApiOptions, source.token)

  try {
    const result = yield* call(getOverrides, apiOptions, action.payload)
    yield put(OverridesFetchActions.success(result.data))
  } catch (e: any) {
    yield put(OverridesFetchActions.failure(e))
  } finally {
    if (yield* cancelled()) {
      source.cancel()
    }
  }
}

export const overridesFetchSagas = [
  () => takeLatest(OverridesFetchActions.request, onRequest)
]
